module.exports = __webpack_public_path__ + "img/dart.8ffbb087.png";